import { sentenceCase } from 'change-case';
import { useCallback, useEffect, useState } from 'react';
// material
import {
  Card,
  Checkbox,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/system';
// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
import { fDate, fDateTime2 } from '../../utils/formatTime';
import RejectedToolbar from './RejectedToolbar';
import { NOT_AVAILABLE } from '../Global/Constants';
import { StyledTableCell, StyledTableRow } from '../../utils/StyleTable';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { getRejectedList } from '../../store/Slice/Rejected/RejectedSlice';
import useRejectedSelector from '../../store/Slice/Rejected/RejectedSelector';
import { isValidValue, normalizeValue, truncateText } from '../../utils/CommonFunction';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';

const TABLE_HEAD = [
  { id: 'leadId', label: 'APPLICATION ID', alignRight: false },
  { id: 'lanId', label: 'Lan Id', alignRight: false },
  { id: 'created', label: 'Submission Date', alignRight: false },
  { id: 'name', label: 'NAME', alignRight: false },
  { id: 'companyName', label: 'Company Name', alignRight: false },
  { id: 'contactNumber', label: 'Contact Number', alignRight: false },
  { id: 'sourceFlag', label: 'File Source', alignRight: false },
  { id: 'loanType', label: 'Product', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'amount', label: 'Amount Requested', alignRight: false },
  { id: 'bankName', label: 'Bank', alignRight: false },

  { id: 'dsaName', label: 'DSA Name', alignRight: false },
  { id: 'status', label: 'status', alignRight: false },
  { id: 'reason', label: 'Reason', alignRight: false },
  { id: 'created', label: 'Last Updated', alignRight: false },
  { id: 'action', label: 'ACTION' }
];

export default function RejectedList() {
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState();
  const [filterName, setFilterName] = useState('');
  const [filterState, setFilterState] = useState({
    product: ' ',
    productId: null,
    productArray: [],
    city: null,
    cityId: null,
    cityArray: [],
    status: ' ',
    statusId: null,
    statusArray: [],
    employmentType: ' ',
    employmentTypeId: null,
    employmentTypeArray: [],
    reason: null,
    bankId: null,
    loanTypeId: null,
    rejectedReasonTypeId: null
  });

  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);

  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);

  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { RejectedListData } = useRejectedSelector();
  const debouncedSearch = useDebounce(filterName, 600);

  const getRejectedListApi = useCallback(() => {
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      stageId: 58,
      filterModel: {
        bankId: filterState.bankId || null,
        loanTypeId: filterState.loanTypeId || null,
        cityId: filterState.cityId || null,
        rejectedReasonTypeId: filterState.rejectedReasonTypeId || filterState.statusId || null
      },
      entityListRequestModel: {
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null,
        sortOrder: order || null
      }
    };
    dispatch(getRejectedList(credentials));
  }, [
    LoginData,
    filterState,
    debouncedSearch,
    order,
    filterDatesRange,
    dispatch,
    page,
    rowsPerPage
  ]);

  useEffect(() => {
    getRejectedListApi();
  }, [getRejectedListApi]);

  useEffect(() => {
    const selectedItem = localStorage.getItem('selectedItem');
    if (selectedItem !== null) {
      localStorage.removeItem('selectedItem');
    }
  }, []);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = RejectedListData?.map((n) => n);
      // console.log('newSelecteds2222', newSelecteds);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  return (
    <Page title="Kpros by Kalolytic Solutions || Rejected">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Rejection Cases" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Card>
            <RejectedToolbar
              numSelected={selected.length}
              filterName={filterName}
              setFilterName={setFilterName}
              onFilterName={handleFilterByName}
              filterDatesRange={filterDatesRange}
              setFilterDatesRange={setFilterDatesRange}
              filterState={filterState}
              setFilterState={setFilterState}
              parent="rejected"
              selected={selected}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, height: '50vh', overflow: 'auto' }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={RejectedListData?.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    isCheckBox="true"
                    parent="rejected"
                  />
                  {/* {console.log(RejectedListData, 'sss RejectedListData')} */}
                  <TableBody>
                    {RejectedListData?.map((item, index) => {
                      const isItemSelected = selected.indexOf(item) !== -1;
                      return (
                        <StyledTableRow
                          hover
                          key={item.applicationId}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, item)}
                            />
                          </TableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.applicationId, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.lanId, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {isValidValue(item?.submissionDate)
                              ? fDate(item.submissionDate)
                              : NOT_AVAILABLE}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.name, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.companyName, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.contactNumber, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Label
                              variant="ghost"
                              color={
                                item?.sourceFlag === 'LOGIN_FILE' ||
                                item?.logInStatusName === 'Rejected'
                                  ? 'warning'
                                  : 'primary'
                              }
                              sx={{
                                opacity: 0.8,
                                fontWeight: 500
                              }}
                            >
                              {normalizeValue(item?.sourceFlag, NOT_AVAILABLE)}
                            </Label>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.loanTypeName, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {truncateText(normalizeValue(item?.cityName, NOT_AVAILABLE), 10)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.amount, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.bankName, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {normalizeValue(item?.dsaName, NOT_AVAILABLE)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Label
                              variant="ghost"
                              color={
                                item?.statusName === 'Closed' || item?.statusName === 'Rejected'
                                  ? 'warning'
                                  : 'success'
                              }
                            >
                              {isValidValue(item?.statusName)
                                ? sentenceCase(item.statusName)
                                : NOT_AVAILABLE}
                            </Label>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {isValidValue(item?.reason) ? item.reason : NOT_AVAILABLE}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {isValidValue(item?.lastUpdatedDate)
                              ? fDate(item.lastUpdatedDate)
                              : NOT_AVAILABLE}
                          </StyledTableCell>
                          <StyledTableCell align="" width={115}>
                            <UserMoreMenu rowId={item} parent="rejected" />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                  {RejectedListData?.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <StyledTableCell align="center" colSpan={12} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
